// extracted by mini-css-extract-plugin
export default {"DynamicPageContainer":"styles_DynamicPageContainer__6+bVc","Description":"styles_Description__sDoUk","imageConitaner":"styles_imageConitaner__2sogv"};